import React from 'react';
import { styled, Box } from '@mui/material';
import HomeNavBar from '../../components/home/HomeNavBar';
import MemberHomeRouting from '../../routing/MemberHomeRouting';
import { LAYOUT_CONSTANTS } from '../../theme';
import { useAppSelector } from '../../hooks/useAppSelector';
import * as uiSlice from '../../data/ui.slice';

const PREFIX = 'ClientLayout';

const classes = {
  container: `${PREFIX}-container`,
  sidebar: `${PREFIX}-sidebar`,
  mainContent: `${PREFIX}-mainContent`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    width: '100%',
    minHeight: `calc(100vh - ${theme.spacing(LAYOUT_CONSTANTS.HEADER_HEIGHT)} - ${theme.spacing(LAYOUT_CONSTANTS.FOOTER_HEIGHT)})`,
  },

  [`& .${classes.sidebar}`]: {
    flexShrink: 0,
    width: theme.spacing(LAYOUT_CONSTANTS.SIDEBAR_WIDTH),
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      display: 'none', // Hide sidebar on mobile
    },
  },

  [`& .${classes.mainContent}`]: {
    flex: 1,
    overflow: 'auto',

    ['& .responsive-container']: {
      padding: theme.spacing(3),
      maxWidth: `calc(${theme.spacing(LAYOUT_CONSTANTS.MAX_CONTENT_WIDTH)} + ${theme.spacing(LAYOUT_CONSTANTS.CONTENT_PADDING)})`,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 'auto',
      height: '100%',
      overflow: 'auto',
    },
  },
}));

function ClientLayout() {
  const navMenuCollapsed = useAppSelector(uiSlice.selectNavMenuCollapsed);

  return (
    <StyledBox className={classes.container}>
      {/* Desktop sidebar - hidden on mobile, or when collapsed via the header toggle */}
      {!navMenuCollapsed && (
        <div className={classes.sidebar}>
          <HomeNavBar />
        </div>
      )}

      {/* Main content area */}
      <div className={classes.mainContent}>
        <main className="responsive-container" id="content">
          <MemberHomeRouting />
          <div className="spacer"></div>
        </main>
      </div>
    </StyledBox>
  );
}

export default ClientLayout;
